<header class="w-full py-3.5 px-3 md:px-5 2xl:px-28 3xl:px-52 bg-OUT-Cream">
  <section class="container mx-auto flex justify-between items-center">
    <div class="">
      <a routerLink="/">
        <img
          alt="Only Used Tesla logo"
          [src]="logoSrc"
          [class]="'max-w-[190px] lg:max-w-[240px]'"
        />
      </a>
    </div>
    <div class="hidden lg:block">
      <ul class="flex gap-5">
        <li class="">
          <a
            routerLink="/used-tesla-for-sale"
            class="font-medium hover:text-OUT-Blue transition-colors duration-300"
            >Used Tesla For Sale</a
          >
        </li>
        <li class="">
          <a
            routerLink="/sell-my-tesla"
            class="font-medium hover:text-OUT-Blue transition-colors duration-300"
            >Sell My Tesla</a
          >
        </li>
      </ul>
    </div>
    <div class="block lg:hidden">
      <button (click)="toggleMobileSidebar()" class="cursor-pointer">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path
            fill="currentColor"
            d="M2 6a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1m0 6.032a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1m1 5.033a1 1 0 1 0 0 2h18a1 1 0 0 0 0-2z"
          />
        </svg>
      </button>
    </div>
  </section>
</header>

<aside class="lg:hidden relative">
  <section
    [ngClass]="isMobileSidebarOpen ? 'translate-x-0' : '-translate-x-full'"
    class="h-screen w-full bg-OUT-Cream fixed top-0 left-0 overflow-hidden duration-300 transition-all z-[500]"
  >
    <section class="p-4">
      <div class="space-y-10">
        <div class="flex justify-between items-center">
          <a routerLink="/">
            <img
              class="size-9"
              src="https://www.onlyusedtesla.com/_nuxt/img/icon-out.cbf95a1.svg"
              alt="Only Used Tesla Logo"
            />
          </a>
          <button
            (click)="toggleMobileSidebar()"
            class="cursor-pointer text-black bg-black/30 transition-colors duration-300 rounded-md"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="35"
              height="35"
              viewBox="0 0 24 24"
            >
              <path
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-miterlimit="10"
                stroke-width="1.5"
                d="m7.757 16.243l8.486-8.486m0 8.486L7.757 7.757"
              />
            </svg>
          </button>
        </div>
        <ul class="flex flex-col gap-3.5 text-2xl">
          <li class="">
            <a
              routerLink="/used-tesla-for-sale"
              class="font-semibold hover:text-OUT-Blue transition-colors duration-300"
              >Used Tesla For Sale</a
            >
          </li>
          <li class="">
            <a
              routerLink="/sell-my-tesla"
              class="font-semibold hover:text-OUT-Blue transition-colors duration-300"
              >Sell My Tesla</a
            >
          </li>
        </ul>
      </div>
    </section>
  </section>
</aside>
